import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useProfile } from "../../api/profileApi";
import { Button, Typography } from "antd";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";


const Navbar = () => {
  const { logout, currentUser } = useAuth();
  const { data: profileData } = useProfile();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };


  const username = currentUser?.username || currentUser?.email?.split('@')[0] || 'User';
  const isLoggedIn = !!currentUser;
  const userPlan = 'Dittrium';

  return (
    <div className="flex justify-between items-center h-16 px-12 w-full bg-white shadow-sm">
      {isLoggedIn ? (
        <>
          <p className="text-md text-black drop-shadow-sm">
            Welcome, <span className="font-semibold">{username}</span>
          </p>
          <Button
            type="primary"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            className="bg-primary hover:bg-primaryLight text-white text-xs rounded-2xl h-9"
            size="middle"
          >
            Log Out
          </Button>
        </>
      ) : (
        <div />
      )}
    </div>
  );
};

export default Navbar;